import { useEffect, type ReactNode } from 'react';

/**
 * Admin dialog: a bottom sheet on phones, a centred panel on desktop. The header
 * and footer stay put while the body scrolls, so a tall form (the template
 * editor especially) never pushes its Save button off-screen.
 */
export function Modal({
  title, onClose, children, footer, wide = false,
}: {
  title: ReactNode;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  wide?: boolean;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = prev; };
  }, [onClose]);

  return (
    <div className="modalWrap" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`modal sheet${wide ? ' sheet-wide' : ''}`} role="dialog" aria-modal="true">
        <div className="sheet-head">
          <h2>{title}</h2>
          <button type="button" className="sheet-x" aria-label="Close" onClick={onClose}>✕</button>
        </div>
        <div className="sheet-body">{children}</div>
        {footer && <div className="sheet-foot">{footer}</div>}
      </div>
    </div>
  );
}
